export default {
  showHidden: 'Show hidden signals',
  deselectAll: 'Deselect All',
  newSignal: 'New virtual signal',
};
